import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';

const PageVideos = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('videos')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    return (
        <div>
            <h1>Vidéos</h1>
            <p>Nous vous fournissons une collection de vidéos de présentation du site et de l'UV. Elles sont complémentaires aux informations textuelles et vous permettent d'avoir des informations complètes sur l'UV.</p>
            <Button align="center" to="?page=videos&id=presentation" type="intern">Présentation de l'UV</Button>
            <Button align="center" to="?page=videos&id=pix" type="intern">Tout savoir sur la certification Pix</Button>
            <Button align="center" to="?page=videos&id=organisation" type="intern">Organisation de l'UV</Button>
            <Button align="center" to="?page=videos&id=modalites" type="intern">Modalités d'obtention de l'UV</Button>
            <Button align="center" icon="arrow-right" to="?page=quizz">Quizz</Button>
        </div>
    );
}

export default PageVideos;